<template>
  <div class="box is-transparent has-text-white">
    <div class="field">
      <div class="field-body" style="font-size: 0.9rem">
        <span style="display: flex;align-items: center;">Click on engine to modify course contents: </span>
        <div class="field has-addons has-addons-right">
          <template v-for="tag in available_tags">
            <b-checkbox-button
              :key="tag"
              v-model="selected_tags"
              :native-value="tag"
              type="is-success"
              class="combination-checkbox"
            >
              <span class="is-size-7">{{ tag }}</span>
            </b-checkbox-button>
          </template>
          <b-checkbox-button
            :key="'show_all'"
            v-model="selected_tags"
            :native-value="'show_all'"
            type="is-success"
            class="combination-checkbox"
          >
            <span class="is-size-7">Show all</span>
          </b-checkbox-button>
        </div>
      </div>
    </div>

    <table  v-if="matched_products.length" class="table is-fullwidth is-vertical-centered is-transparent has-text-white combo-table">
      <tbody>
        <tr v-for="(product, index) in matched_products" :key="product.id">
          <td class="is-hidden-mobile p-0" :class="index !== matched_products.length - 1 ? 'border-bottom-white' : ''">
            <div v-if="product.images['16by9']" class="is-flex is-align-items-center my-1" style="padding: 0.5em">
              <figure class="image combo-product-image-borders">
                <img :src="product.images['16by9']" class="has-ratio" style="min-width: 50px; max-width: 130px;" alt="">
              </figure>
            </div>
          </td>
          <td :class="index !== matched_products.length - 1 ? 'border-bottom-white' : ''">
            <a :href="product.url" title="View product" class="combo-product-title mx-2 has-text-weight-bold">
              {{ product.name }}
            </a>
          </td>
          <td :class="index !== matched_products.length - 1 ? 'border-bottom-white' : ''">
            <div class="is-flex is-align-items-center is-justify-content-start" style="white-space: nowrap;" >
              <span class="has-text-weight-bold combo-price" v-html="product.formatted_price"></span>
            </div>
          </td>
          <td :class="index !== matched_products.length - 1 ? 'border-bottom-white' : ''">
            <button class="button is-small is-info is-outlined is-inverted" @click.prevent="addToCart({ product_id: product.id, quantity: 1 })">
              <i class="fa fa-shopping-cart" style="margin-right: 10px;"></i>
              Add to cart
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<style lang="scss">
.combo-price {
  font-size: 1.5rem;
  font-weight: 600;

  .right {
    display: none;
  }
}
.combination-checkbox {
  .b-checkbox {
    &:hover:not(.is-success) {
      background-color: #fff !important;
      color: #00bcd4 !important;
    }
  }
  .b-checkbox:not(.is-success) {
    background-color: transparent;
    color: white;
  }
}

.combo-table {
  margin-bottom: 0;
  border: 1px solid;
  border-radius: 4px;
  border-collapse: separate;
}

.border-bottom-white {
  border-bottom: 1px solid white !important;
}

.combo-product-title {
  font-size: 0.9rem;
  font-weight: 500;
}
.combo-product-image-borders {
  box-shadow: 1px 2px 6px -2px #6e798f;
  -webkit-box-shadow: 1px 2px 6px -2px #6e798f;
  -moz-box-shadow: 1px 2px 6px -2px #6e798f;
}
</style>

<script>
import Cart from '../../mixins/Cart';

export default {
  name: 'AddToCartFromProductCombinations',
  mixins: [Cart],
  props: {
    product_id: { required: true, type: String },
    combinations: { required: true, type: Array }
  },
  data() {
    let tags = [];
    this.combinations.forEach(product => {
      product.combination_tags.forEach(tag => {
        tags.push(tag);
      });
    });
    //remove duplicates
    tags = [...new Set(tags)];
    return {
      available_tags: tags,
      selected_tags: ['show_all'],
      matched_products: []
    };
  },
  watch: {
    selected_tags(val) {
      if (val[0] === 'show_all' && val[1]) {
        //if other tags is selected remove show_all if it was selected first
        this.selected_tags = val.filter(function (item) {
          return item !== 'show_all';
        });
      }
      this.setDefaultMatchedProducts(val);
    }
  },
  mounted() {
    this.setDefaultMatchedProducts(this.selected_tags);
  },
  methods: {
    setDefaultMatchedProducts(selected_tags) {
      this.matched_products = [];
      this.combinations.forEach(product => {
        if (selected_tags.every(r => product.combination_tags.includes(r)) || selected_tags.includes('show_all')) {
          this.matched_products.push(product);
        }
      });
    }
  }
};
</script>
